import { useState, useRef, useEffect, useContext } from "react";
import { useOutletContext, useParams, useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    Grid2 as Grid,
    LinearProgress,
    Tooltip,
    Typography,
} from '@mui/material';
import { AccountCircle, Add, Cancel, Check, CleanHands, ClearAll, Delete, Download, Edit, Info, Message, PictureAsPdf, PlayArrow, QrCode, Save } from '@mui/icons-material';
import { checkComponentPresence, propComparator, getSelectedElement, getCategoryColor, propComparatorDate } from "../utils/ui_utils";

import { CategoryDialog } from "../modals/CategoryDialog";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { add_Category, delete_Category, edit_Category, get_Category_list } from "../FirebaseUtils/dbCategory";
import { useEvent } from "../context/eventContext";
import { useAuth } from "../core/AuthProvider";
import { CategoryTemplateMenu } from "../modals/CategoryTemplateManagementDialog";
import { edit_Cow, get_Cow_list } from "../FirebaseUtils/dbCow";
import { globalstyles } from "../lib/definitions";
import { CowSublistDialog } from "../modals/CowSublistDialog";
import { ContainerPdfDialog } from "../modals/PdfContainerDialog";
import { getCategoryLight } from "../definitions/category";
import { get_Cowman_list } from "../FirebaseUtils/dbCowman";
import { get_Property_list } from "../FirebaseUtils/dbProperty";
import { CowtypeListBadge } from "../components/CowtypeListBadge";
import { PresenceSummary } from "../components/PresenceButton";




export default function CategoryListPage() {
    const { user } = useAuth()
    const dialogRef = useRef()
    const childRefDelete = useRef()
    const cowlistRef = useRef()
    const pdfRef = useRef()

    const { event_id } = useParams()
    const { selEvent } = useEvent()

    const [element_list, setElementList] = useState([])
    const [cow_list, setCowList] = useState([])
    const [isLoading, setIsLoading] = useState(true)


    const handleNew = () => {
        dialogRef.current.onNew()
    }


    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const get_cowmanlist = async () => {
        const res = await get_Cowman_list(selEvent.id)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('name'))
    }

    const handlePdf = async () => {
        const cmlist = await get_Property_list(selEvent.id)
        pdfRef.current.onOpen({ category_list: element_list, cow_list: cow_list, cowman_list: cmlist }, 'catalogo', 'catalog')
    }



    const handleDelete = (r, i) => {
        const cb = () => {
            delete_Category(event_id, r.id)
            setElementList(lst => {
                let _el = [...lst]
                _el.splice(i, 1)
                return _el
            })
        }
        childRefDelete.current.confirmDelete('Cancella Categoria', `Sei sicuro di voler cancellare la categoria: <b>${r.category_name}</b>`, cb)
    }

    const addFn = async (el) => {
        const res = await add_Category(user.uid, event_id, el)
        reloadFn()
    }
    const editFn = async (el) => {
        console.log("EDIT CATEGORYY", user.uid, event_id, el.id, el)
        const res = await edit_Category(user.uid, event_id, el.id, el)
        reloadFn(el)

    }
    const reloadFn = async (el) => {
        setIsLoading(true)
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                }
                _el = _el.sort(propComparator('category_number'))
                return _el

            })


        } else {
            const data = await get_Category_list(event_id)
            setElementList(data.sort(propComparator('category_number')))
            const cdata = await get_Cow_list(event_id)
            let c_list = cdata.sort(propComparatorDate('birthdate', true, 'catalog_id'))
            c_list.reverse()
            setCowList(c_list)
        }
    }

    const addCowList = (add_cow_data) => {
        const _cat = getSelectedElement(add_cow_data.id, element_list, 'id')
        for (const c of add_cow_data.new_cow_list) {
            let cow = getSelectedElement(c.id, cow_list, 'id')
            cow.category = getCategoryLight(_cat)
            console.log(cow)
            edit_Cow(user.uid, event_id, cow.id, cow)
        }
        reloadFn()
        const new_el = { ..._cat, cow_list: add_cow_data.cow_list }
        console.log(new_el, add_cow_data, _cat)
        //        editFn(new_el)
    }
    const showCowlist = (cl, cat) => {
        cowlistRef.current.onOpen(cl, { id: cat.id, title: cat.category_name + " " + cat.category_description })
    }


    useEffect(() => {
        console.log("EVENT_id", event_id, selEvent)
        //setSelEvent(event_id)
        reloadFn()

    }, [event_id])


    useEffect(() => {
        setIsLoading(false)

    }, [element_list])


    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <CategoryDialog ref={dialogRef} reloadFn={reloadFn} event_id={event_id} addFn={addFn} editFn={editFn} />
            <CowSublistDialog ref={cowlistRef} handleAddCowList={addCowList} />
            <ContainerPdfDialog ref={pdfRef} />
            <>
                <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <Grid size={3} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                        Lista categorie
                    </Grid>
                    <Grid size={"grow"} sx={{ textAlign: 'right' }}>
                        <ButtonGroup size="small">
                            <Button onClick={handlePdf} startIcon={<PictureAsPdf />}>pdf catalogo </Button>
                            {/*                                 <CatalogInitNumberDialog category_list={element_list} cow_list={cow_list} reloadFn={reloadFn} />
                                <CategoryAssignemntWizardDialog event_id={selEvent.id}
                                    cow_list={cow_list} category_list={element_list} /> */}
                            <CategoryTemplateMenu category_list={element_list} reloadFn={reloadFn} childRefDelete={childRefDelete} />

                            <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo categoria</Button>
                        </ButtonGroup>
                    </Grid>
                </Grid>
                {element_list.length === 0 ?
                    <Typography sx={globalstyles.missing_value}>
                        Nessuna categoria inserita
                    </Typography>

                    :
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size="grow">
                            nome
                            <Box style={{ fontSize: '0.7em' }}>descrizione</Box>
                        </Grid>
                        <Grid size="grow">
                            sezione
                        </Grid>
                        <Grid size="grow">
                            categoria
                        </Grid>
                        <Grid size="grow">
                            età (mesi)
                        </Grid>
                        <Grid size="grow">
                            parti
                        </Grid>
                        <Grid size="grow">
                            soggetti<br />
                            <Box sx={{ fontSize: '0.7em', fontStyle: 'italic' }}>black/red</Box>
                        </Grid>
                        <Grid size={2} sx={{ textAlign: 'right' }}>
                        </Grid>

                    </Grid>
                }

                {isLoading ?
                    <LinearProgress />
                    :
                    <>
                        <Grid >


                            {element_list.map((s, k) => (
                                <OneCategory
                                    key={k}
                                    category={s}
                                    index={k}
                                    cow_list={cow_list.filter(c => c.category && c.category.id === s.id)}
                                    handleEdit={handleEdit}
                                    handleDelete={handleDelete}
                                    showCowlist={showCowlist}
                                />
                            ))}
                        </Grid>
                    </>
                }
            </>
        </Box >
    );
}


const OneCategory = ({ category, index, handleDelete, handleEdit, showCowlist, cow_list }) => {




    return (
        <Grid container sx={{ ...globalstyles.list_row, color: getCategoryColor(category.cow_list?.length) }}>

            <Grid size={"grow"} >
                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                    {category.category_name}
                </Grid>
                <Grid size={"grow"} sx={{ fontSize: '0.8em' }}>
                    {category.category_description}
                </Grid>
            </Grid>
            <Grid size={"grow"}>
                {category.category_section}
            </Grid>
            <Grid size={"grow"}>
                {category.category_number}
            </Grid>
            <Grid size={"grow"}>
                {category.cow_age_months_start}-
                {category.cow_age_months_end}
            </Grid>
            <Grid size={"grow"}>
                {category.cow_birth_start}
                {category.cow_birth_end > category.cow_birth_start + 1 &&
                    <>-
                        {category.cow_birth_end}
                    </>}
            </Grid>
            <Grid sx={{ textAlign: "center" }} size={"grow"} justifyContent={"center"} alignContent={"center"} alignItems={"center"} alignSelf={"center"}>
                <Button size="small" variant="outlined" color={cow_list?.length > 0 ? "secondary" : 'warning'} onClick={() => showCowlist(cow_list, category)}>
                    <Grid sx={{ lineHeight: '14px' }}>
                        <Grid>
                            {cow_list ?
                                cow_list.length
                                :
                                0
                            }
                        </Grid>
                        <Grid>

                        <PresenceSummary element_list={cow_list} />
                        </Grid>
                        <CowtypeListBadge cow_list={cow_list} />
                    </Grid>
                </Button>
            </Grid>
            <Grid size={2} sx={{ textAlign: 'right' }}>
                <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={() => handleEdit(category, index)} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <Button color="error" onClick={() => handleDelete(category, index)} startIcon={<Delete />}></Button>
                    </Tooltip>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}




